import type { App } from "vue";
import type { Router } from "vue-router";

type SentryVueOptions = {
	app: App;
	router: Router;
	dsn: string;
};

const SENTRY_ENVIRONMENTS = ["production", "staging"] as const;

/**
 * Standardised Sentry SDK initialisation for BibliU Vue applications.
 * Uses dynamic import to keep Sentry (~150KB gzip) out of the initial bundle.
 */
export function sentryVue({ app, router, dsn }: SentryVueOptions) {
	if (SENTRY_ENVIRONMENTS.includes(import.meta.env.VITE_DEPLOY_ENV)) {
		import("@sentry/vue")
			.then((Sentry) => {
				Sentry.init({
					app,
					dsn,
					environment: import.meta.env.VITE_DEPLOY_ENV,
					integrations: [
						Sentry.browserTracingIntegration({ router }),
						Sentry.replayIntegration({
							maskAllText: false,
							blockAllMedia: false,
						}),
					],
					tracesSampleRate: 1.0,
					replaysSessionSampleRate: 0.0,
					replaysOnErrorSampleRate: 1.0,

					// This gets set in web/shared/plugins/sentry.ts
					release: import.meta.env.VITE_RELEASE_TAG,
				});
			})
			.catch(() => {});
	}
}
